import axios from 'axios'
import { initShopeepayReporter, instrumentAxios } from '@shopeepay/reporter'

initShopeepayReporter({ region: 'vn', project: 'shopeepay-vn' })
instrumentAxios(axios, 'shopeepay-vn')
